import React, { useState } from 'react';
import { MapContainer, TileLayer, useMap, Marker, Popup } from 'react-leaflet';
import { Icon } from 'leaflet';
import MarkerBigIcon from 'leaflet/dist/images/marker-icon-2x.png';
import MarkerStandartIcon from 'leaflet/dist/images/marker-icon.png';
import smallBlueIcon from '../../img/icons8-circled-notch-12-blue.png';
import smallGreenIcon from '../../img/icons8-circled-notch-12-green.png';

import 'leaflet/dist/leaflet.css';
import './MapPlaceholder.css';

// Кнопка для повноекранного режиму
const FullScreenControl = () => {
  const map = useMap();
  
  const toggleFullScreen = () => {
    const container = map.getContainer();
    
    if (!document.fullscreenElement) {
      if (container.requestFullscreen) {
        container.requestFullscreen();
      } else if (container.webkitRequestFullscreen) {
        container.webkitRequestFullscreen();
      } else if (container.msRequestFullscreen) {
        container.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  };

  return (
    <div className="leaflet-top leaflet-right">
      <div className="leaflet-control">
        <button 
          className="fullscreen-toggle" 
          onClick={toggleFullScreen}
          title="Розгорнути на весь екран"
        >
          ⛶
        </button>
      </div>
    </div>
  );
};

const MapPlaceholder = ({ kglist = [] }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const IconView = new Icon({
    iconUrl: kglist.length < 3 ? MarkerBigIcon : kglist.length > 10 ? smallBlueIcon : MarkerStandartIcon, 
  });

  const position = [50.447978, 30.522384];

  // Обробник подій повноекранного режиму
  React.useEffect(() => {
    const handleFullScreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullScreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullScreenChange);
    document.addEventListener('msfullscreenchange', handleFullScreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullScreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullScreenChange);
      document.removeEventListener('msfullscreenchange', handleFullScreenChange);
    };
  }, []);

  return (
    <div className={`map-container ${isFullScreen ? 'fullscreen' : ''}`}>
      <MapContainer 
        center={position} 
        zoom={10}
        minZoom={10} 
        scrollWheelZoom={true}
        className="map-placeholder"
      >
        <TileLayer
          attribution='&copy; iefrstudio powered <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FullScreenControl />
        {kglist.map(kg => (
          <Marker 
            key={kg._id}
            position={[kg.contacts.address.lat, kg.contacts.address.lon]}
            icon={IconView} 
          >
            <Popup>
              <a href={`object/${kg._id}`}>{kg.number} {kg.name}</a><br /> 
              {kg.contacts.address.string}.
            </Popup>
          </Marker>
        ))}
      </MapContainer>
      
      {!isFullScreen && (
        <div className="map-hint">
          <small>Натисніть ⛶ для повноекранного перегляду</small>
        </div>
      )}
    </div>
  );
};

export default MapPlaceholder;